import React, { useState } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import Items from "./schema.json";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { mapIcon } from '../../lib/helpers';
import logo from '../../assets/sidebarLogo.png';

const Sidebar = ({ hovered, updateHovered, isMobile, sidebarClosed, setSidebarClosed }) => {
  const history = useHistory();
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState(new Set());

  const toggleSubMenu = (menuId, e) => {
    e.stopPropagation();
    const newSet = new Set(expandedMenus);
    if (newSet.has(menuId)) newSet.delete(menuId);
    else newSet.add(menuId);
    setExpandedMenus(newSet);
  };

  const isSubMenuExpanded = (menuId) => expandedMenus.has(menuId);

  const isActiveParent = (item) => {
    if (location.pathname === item.path) return true;
    if (item.subCats) {
      return item.subCats.some(sub => location.pathname === sub.subPath);
    }
    return false;
  };

  const handleNavigation = (path) => {
    history.push(path);
    if (isMobile) setSidebarClosed(true);
  };

  const isSidebarOpen = !sidebarClosed || (hovered && !isMobile);
  const sidebarWidth = isSidebarOpen ? '220px' : '80px';

  return (
    <>
      {isMobile && !sidebarClosed && (
        <div 
          onClick={() => setSidebarClosed(true)}
          style={{
            position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)',
            zIndex: 1000, backdropFilter: 'blur(3px)'
          }} 
        />
      )}

      <div 
        onMouseEnter={() => !isMobile && updateHovered(true)}
        onMouseLeave={() => !isMobile && updateHovered(false)}
        style={{
          width: isMobile ? '220px' : sidebarWidth,
          height: '100vh',
          backgroundColor: '#0f2335',
          transition: 'all 0.3s ease',
          position: 'fixed',
          left: 0, top: 0, zIndex: 1001,
          overflowY: 'auto', overflowX: 'hidden',
          display: 'flex', flexDirection: 'column',
          transform: isMobile && sidebarClosed ? 'translateX(-100%)' : 'translateX(0)',
          borderRight: '1px solid rgba(255,255,255,0.05)'
        }}
      >
        <div style={{ textAlign: 'center', padding: '30px 10px' }}>
          <img src={logo} alt="logo" style={{
            maxWidth: isSidebarOpen ? '70px' : '40px',
            transition: 'all 0.3s ease',
            filter: 'brightness(0) invert(1)'
          }} />
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          {Items.map((item) => (
            <div key={item.id || item.name} style={{ position: 'relative' }}>
              <div 
                onClick={(e) => item.subCats ? toggleSubMenu(item.id || item.name, e) : handleNavigation(item.path)}
                style={{
                  display: 'flex', alignItems: 'center', gap: '15px',
                  padding: isSidebarOpen ? '14px 24px' : '15px 0',
                  justifyContent: isSidebarOpen ? 'flex-start' : 'center',
                  cursor: 'pointer', color: isActiveParent(item) ? '#4de7ef' : '#8fa3b4',
                  backgroundColor: isActiveParent(item) ? 'rgba(255,255,255,0.04)' : 'transparent',
                  transition: 'all 0.2s ease',
                  borderLeft: isActiveParent(item) ? '4px solid #4de7ef' : '4px solid transparent'
                }}
              >
                <FontAwesomeIcon icon={mapIcon(item.icon)} style={{ fontSize: '20px', minWidth: '24px' }} />
                {isSidebarOpen && <span style={{ flex: 1, whiteSpace: 'nowrap' }}>{item.name}</span>}
                {isSidebarOpen && item.subCats && (
                  <FontAwesomeIcon 
                    icon={mapIcon('faCaretDown')} 
                    style={{ 
                        fontSize: '12px', 
                        transform: isSubMenuExpanded(item.id || item.name) ? 'rotate(180deg)' : 'none', 
                        transition: '0.3s' 
                    }} 
                  />
                )}
              </div>

              {isSidebarOpen && item.subCats && isSubMenuExpanded(item.id || item.name) && (
                <div style={{ background: 'rgba(0,0,0,0.15)', padding: '5px 0' }}>
                  {item.subCats.map(sub => (
                    <div 
                      key={sub.subPath}
                      onClick={() => handleNavigation(sub.subPath)}
                      style={{
                        padding: '10px 20px 10px 45px', cursor: 'pointer', fontSize: '0.95rem',
                        color: location.pathname === sub.subPath ? '#4de7ef' : '#7a8d9d',
                        display: 'flex', alignItems: 'center', gap: '12px'
                      }}
                    >
                      <FontAwesomeIcon icon={mapIcon(sub.subIcon)} style={{ fontSize: '18px' }} />
                      <span>{sub.name}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Sidebar;